import { render, staticRenderFns } from "./SCWorkTypeFilter.vue?vue&type=template&id=19a90026"
import script from "./SCWorkTypeFilter.vue?vue&type=script&lang=js"
export * from "./SCWorkTypeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports